export const SECTION_DESCRIPTION = ''

export const INFORMATION_FIELDS = [
  { label: 'Nama Pegawai', value: '-', is_visible: true },
  { label: 'ID Pegawai', value: '-', is_visible: true },
  { label: 'Lokasi', value: '-', is_visible: true },
  { label: 'Periode Komisi', value: '-', is_visible: true },
  { label: 'NIK KTP', value: '-', is_visible: true },
  { label: 'Informasi Transfer', value: '-', is_visible: true },
] as const
